import { getAnalyticEvent } from '../analytics';
import { IFeedback } from '../interfaces';
import { USER_FEEDBACK } from '../utils/constants';
import httpClient from './http';

export const sendFeedback = (feedback: IFeedback) => {
  const event = getAnalyticEvent(USER_FEEDBACK, feedback);
  return httpClient.post('/api/feedback', [event]);
};
